import { connect } from 'react-redux';
import PengajuanKegiatan from '../../../views/Personnel/Absensi/PengajuanKegiatan.absensi.view';
import { getAssignment } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAssignment: payload => dispatch(getAssignment(payload)),
  };
}

export default connect(null, mapDispatchToProps)(PengajuanKegiatan);